import TagManager from 'react-gtm-module'

import { 
    SET_VOLUME,
    SET_AUDIO_TO_PLAY,
    INCREMENT_AUDIO_COUNT,
    INCREMENT_STOP_AUDIO_COUNT,
    SET_MENU_STATE,
    SET_OVERLAY_STATE,
    SET_SECTION_AS_ANIMATED,
    SET_USER_INTERACTED,
    TRIGGER_GTM_PUSH,
    SET_NAV_METHOD_FOR_GTM
} from "../constants/action-types";

import all_audio from '../../model/all-audio';
const VALID_AUDIO_KEYS = Object.keys(all_audio);

const initialState = {
    userInteracted: false,
    volumeIsOn: null,
    audioPlayCount: 0,
    audioStopCount: 0,
    audioToPlay: null, 
    menuIsOpen: false,
    overlayIsActive: false,
    animatedSections: [],
    gtm: {
      'event': 'pageLoad',
      'virtualPath':'/',
      'pageNo': 'undefined',
      'pageName': 'undefined',
      'navMethod': 'Begin',
      'quizAnswer': 'undefined'
    }
}

const sendGTMEvent = (events) => {
  const tagManagerArgs = {
    dataLayer: events,
    dataLayerName: 'dataLayer'
  }
  TagManager.dataLayer(tagManagerArgs)
}

const rootReducer = (state = initialState, action) => {
    if (typeof action === 'undefined')  return state

    switch (action.type) {
        case TRIGGER_GTM_PUSH:
          const newGtmData = {...state.gtm, ...action.eventData}
          sendGTMEvent(newGtmData)
          return {...state, gtm: newGtmData}
        case SET_NAV_METHOD_FOR_GTM:
          return {...state, gtm: {...state.gtm, navMethod: action.method}}
        case SET_USER_INTERACTED:
            return {
                ...state,
                userInteracted: true
            }
        case SET_VOLUME:
            return { ...state,
                volumeIsOn: action.volumeIsOn
            };
        case INCREMENT_AUDIO_COUNT:
            return {
                ...state,
                audioPlayCount: state.audioPlayCount + 1,
            };
        case INCREMENT_STOP_AUDIO_COUNT:
            return {
                ...state,
                audioStopCount: state.audioStopCount + 1,
            };
        case SET_AUDIO_TO_PLAY:
            let { payload } = action;
            if (VALID_AUDIO_KEYS.indexOf(payload) > -1) {
                return {
                    ...state,
                    audioToPlay: payload
                };
            } else {
                // Validate audio key, and warn when in development server
                if (process.env.NODE_ENV === 'development') {
                    console.warn(`Invalid audio key passed to play: "${payload}"`, action);
                }

                return state;
            }
            
        case SET_MENU_STATE:
            return { ...state,
                menuIsOpen: action.menuIsOpen
            };
        case SET_OVERLAY_STATE:
            return { ...state,
                overlayIsActive: action.overlayIsActive
            };
        case SET_SECTION_AS_ANIMATED:
            return {
                ...state, 
                animatedSections: [...state.animatedSections, action.sectionId]
            }
        default:
            return state;
    }
};

export default rootReducer;
